import React from 'react';
import ReactDOM from 'react-dom';
import { DatePicker } from '@wearesection/raise-ui/atoms';

function ReactRenderDatePickerBlock( datepicker: HTMLElement ) {
	// integrate DatePicker from DLS for Hubspot date field
	if ( datepicker ) {
		const currentForm = datepicker.closest( 'form' ) as HTMLFormElement;

		const handleChangeDate = ( date: Date ) => {
			const initialHSDateField = Array.from(
				datepicker.querySelectorAll( '.hs-initial-date-field input' ),
			) as HTMLInputElement[];
			const year = date.getFullYear();
			const month = String( date.getMonth() + 1 ).padStart( 2, '0' );
			const day = String( date.getDate() ).padStart( 2, '0' );
			const formattedDate = `${ year }-${ month }-${ day }`; // yyyy-mm-dd
			if ( initialHSDateField ) {
				initialHSDateField.forEach( item => {
					item.value = formattedDate;
					item.dispatchEvent( new Event( 'change', { bubbles: true } ) );
					currentForm.dispatchEvent( new Event( 'change', { bubbles: true } ) );
				} );
			}
		};
		ReactDOM.render(
			<>
				<div
					className="hs-initial-date-field hidden"
					dangerouslySetInnerHTML={ { __html: datepicker.innerHTML } }
				/>
				<DatePicker onChange={ handleChangeDate } />
			</>,
			datepicker,
		);
	}
}

export default ReactRenderDatePickerBlock;
